import { memo, useEffect, useState } from "react";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import { useLocation } from "react-router-dom";
import DataChanneling from "../GeneralFunctions/DataChanneling";

function ToggleSwitch({ label, ifInfo, message, name, ifInfoMessage, browserSupportText }) {
  const {
    toggleStates,
    setToggleStates,
    setIsInstructorMode,
    isInstructorMode,
    setIsFitToFrame,
    isFitToFrame,
    callN,
    isCam,
    role,
    setAttendees,
    eventType,
    isClassScreen,
    isMic
  } = useLiveStreamAppContext();

  const { sendActionToAttendee } = DataChanneling();

  const [tooltipCheck, setTooltipCheck] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (tooltipCheck) {
      setTimeout(() => {
        setTooltipCheck(false);
      }, 2000)
    }
  }, [tooltipCheck])

  useEffect(() => {
    if (
      toggleStates["InstructorMode"] &&
      (toggleStates["EnableVideo"] ||
        toggleStates["EnableMic"] ||
        toggleStates["EnableScreenShare"])
    ) {
      setToggleStates((prevStates) => ({
        ...prevStates,
        EnableMic: false,
        EnableVideo: false,
        EnableScreenShare: false,
      }));
    }
  }, [toggleStates]);

  //Function to Change the state when toggle switches are clicked
  const handleToggleClickMedia = (e) => {
    const { name, checked } = e.target;

    setAttendees((prevAttendees) =>
      prevAttendees.map((attendee) => ({
        ...attendee,
        ...(name === "EnableChat" && { isChatDisabled: !checked }),
        ...(name === "EnableScreenShare" && { isScreenShareDisabled: !checked }),
      }))
    );

    setToggleStates((prevStates) => {
      const newState = { ...prevStates, [name]: !prevStates[name] };
      if (name === "blurBackground" && !callN.current?.isLocalVideoStarted) {
        if (["/livestream/meeting", "/meeting"].includes(location.pathname) || !isCam) {
          return prevStates;
        }
      }

      if (name === "mirrorMyVideo" && !callN.current?.isLocalVideoStarted) {
        if (["/livestream/meeting", "/meeting"].includes(location.pathname) || !isCam) {
          return prevStates;
        }
      }

      if (name === "removeBackgroundNoise" && !isMic) {
        return prevStates;
      }

      if (name === "removeBackgroundNoise" && role === "Attendee" && !toggleStates.EnableMic) {
        if (["/livestream/meeting", "/meeting"].includes(location.pathname) || !isCam) {
          return prevStates;
        }
      }

      if (name === "shareDeviceAudio" && role === "Attendee" && (!toggleStates.EnableMic || eventType === 2)) {
        if (["/livestream/meeting", "/meeting"].includes(location.pathname) || !isCam) {
          return prevStates;
        }
      }

      if (name === "InstructorMode") setIsInstructorMode(!isInstructorMode);
      if (name === "FitToFrame") setIsFitToFrame(!isFitToFrame);

      // Handle remote participant toggles
      const toggleActions = {
        EnableMic: ["ENABLE_MIC_FOR_ALL", "DISABLE_MIC_FOR_ALL"],
        EnableVideo: ["ENABLE_VIDEO_FOR_ALL", "DISABLE_VIDEO_FOR_ALL"],
        EnableChat: ["ENABLE_CHAT_FOR_ALL", "DISABLE_CHAT_FOR_ALL"],
        EnableScreenShare: ["ENABLE_SCREEN_SHARE_FOR_ALL", "DISABLE_SCREEN_SHARE_FOR_ALL"],
      };

      if (window.location.pathname.includes("/meeting") && toggleActions[name]) {
        sendActionToAttendee("ALL", newState[name] ? toggleActions[name][0] : toggleActions[name][1]);
      }

      return newState;
    });
  };

  return (
    <>
      <div
        id={name + "div"}
        className={`switch-checkbox-meet host-switch
          ${name === "blurBackground" && !isCam ? "divDisabled" : ""}
          ${name === "mirrorMyVideo" && !isCam ? "divDisabled" : ""}
          ${name === "removeBackgroundNoise" && !isMic ? "divDisabled" : ""}
        `}
      >
        <input
          type="checkbox"
          id={name}
          name={name}
          checked={toggleStates[name]}
          onChange={(e) => {
            handleToggleClickMedia(e);
          }}
          disabled={
            (toggleStates["InstructorMode"] && (name === "EnableVideo" || name === "EnableMic" || name === "EnableScreenShare")) ||
            (role === "Attendee" && name === "shareDeviceAudio" && eventType === 2)
          }
        />
        {label && <label htmlFor={name}>{label}</label>}
        {ifInfo &&
          !(role === "Attendee" && eventType === 1 && !isClassScreen) && (
            <span className="tooltip-new">
              <span className="Instructor-Tool-icon">
                <i className={`fal fa-info-circle mob-tooltip ${name === "shareDeviceAudio" ? "shareDeviceAudioTooltip" : ""} ${tooltipCheck ? "tooltipShowState" : ""}`}>
                  <span
                    id="InstructorToolTip"
                    className="tooltiptext"
                  >
                    {ifInfoMessage}
                  </span>
                </i>
              </span>
            </span>
          )}
        {toggleStates["InstructorMode"] &&
          (name === "EnableVideo" ||
            name === "EnableMic" ||
            name === "EnableScreenShare") && (
            <span className="tooltip-new">
              <span className="Instructor-Tool-icon">
                <i className="fal fa-info-circle mob-tooltip">
                  <span id="InstructorToolTip" className="tooltiptext">
                    This cannot be changed when Instructor Only Mode is on.
                  </span>
                </i>
              </span>
            </span>
          )}
        {message && (
          <div className="Inst-text">
            <span>{message}</span>
          </div>
        )}
        {browserSupportText && (
          <div className="Inst-text">
            <span>{browserSupportText}</span>
          </div>
        )}
      </div>
    </>
  );
}
export default memo(ToggleSwitch);